// extracted by mini-css-extract-plugin
module.exports = {"companyImg":"ServiceReportHeader_companyImg__V34aG","dp_flex":"ServiceReportHeader_dp_flex__49AiS"};